import { useState, useEffect, useCallback } from 'react';
import { api } from '../services/api';

const useVerrouillageNotes = () => {
  const [config, setConfig] = useState([]);
  const [classes, setClasses] = useState([]);
  const [etatClasse, setEtatClasse] = useState(null);
  const [historique, setHistorique] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, limit: 50, offset: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Charger la configuration des délais
  const chargerConfig = useCallback(async () => {
    try {
      setLoading(true);
      const result = await api.notesVerrouillage.getConfig();
      if (result.success) {
        setConfig(result.data);
      }
    } catch (err) {
      console.error('❌ Erreur chargement config:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // Charger la liste des classes
  const chargerClasses = useCallback(async () => {
    try {
      const result = await api.notesVerrouillage.getClasses();
      if (result.success) {
        setClasses(result.data);
      }
    } catch (err) {
      console.error('❌ Erreur chargement classes:', err);
    }
  }, []);

  // Modifier le délai d'une section
  const modifierDelai = useCallback(async (configId, delai) => {
    try {
      setLoading(true);
      const result = await api.notesVerrouillage.updateConfig(configId, delai);
      if (result.success) {
        await chargerConfig();
      }
      return result;
    } catch (err) {
      console.error('❌ Erreur modification délai:', err);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  }, [chargerConfig]);

  // Charger l'état des verrouillages d'une classe
  const chargerEtatClasse = useCallback(async (classeId, annee_scolaire_id, options = {}) => {
    try {
      setLoading(true);
      setError(null);
      const result = await api.notesVerrouillage.getEtatClasse(classeId, annee_scolaire_id, options);
      if (result.success) {
        setEtatClasse(result.data);
      } else {
        setEtatClasse(null);
        setError(result.error);
      }
      return result;
    } catch (err) {
      console.error('❌ Erreur chargement état classe:', err);
      setEtatClasse(null);
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  }, []);

  // Déverrouiller des notes
  const deverrouiller = useCallback(async (params) => {
    try {
      setLoading(true);
      setError(null);
      const result = await api.notesVerrouillage.deverrouiller(params);
      return result;
    } catch (err) {
      console.error('❌ Erreur déverrouillage:', err);
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  }, []);

  // Charger l'historique
  const chargerHistorique = useCallback(async (params = {}) => {
    try {
      setLoading(true);
      const result = await api.notesVerrouillage.getHistorique(params);
      if (result.success) {
        setHistorique(result.data);
        setPagination(result.pagination);
      }
      return result;
    } catch (err) {
      console.error('❌ Erreur chargement historique:', err);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  }, []);

  // Chargement initial
  useEffect(() => {
    chargerConfig();
    chargerClasses();
  }, [chargerConfig, chargerClasses]);

  return {
    config,
    classes,
    etatClasse,
    historique,
    pagination,
    loading,
    error,
    chargerConfig,
    chargerClasses,
    modifierDelai,
    chargerEtatClasse,
    deverrouiller,
    chargerHistorique
  };
};

export default useVerrouillageNotes;